import { Component, OnInit } from '@angular/core';
import { AccessaryService } from 'src/app/shared/services/accessary.service';
import { Accessory } from '../accessory.model';
import { Router, ActivatedRoute } from '@angular/router';
import { Options } from 'ng5-slider';
import { Category } from '../accessory-cat/accessory-cat.model';
import { Brand } from 'src/app/includes/sidebar/sidebar.model';
import { BannerService } from 'src/app/shared/services/banner.service';
import { Banner } from '../home/home.model';
declare var $: any;
@Component({
    selector: 'app-accessory-list',
    templateUrl: './accessory-list.component.html',
    styleUrls: ['./accessory-list.component.scss']
})
export class AccessoryListComponent implements OnInit {
    accessories: Accessory;
    brands: Brand;
    brandName: string;
    getBy: string;
    accessoryType: string;
    minValue: number;
    maxValue: number;
    page = 1;
    metadata = {
        limit: 0,
        offset: 0,
        total: 0
    };
    sortDatePrice = 'new';
    cat: Category;
    type = '';
    filterValue: string;
    options: Options = {
        floor: 0,
        ceil: 1000,
        translate: (value: number): string => {
            return '$' + value;
        }
        // combineLabels: (minValue: string, maxValue: string): string => {
        //   return "from " + minValue + " up to " + maxValue;
        // }
    };

    banners: Banner;

    constructor(
        private AccessaryService: AccessaryService,
        private route: ActivatedRoute,
        private router: Router,
        private bannerService: BannerService
    ) {
        this.route.params.subscribe(Response => {
            this.getBy = Response.getBy;
            this.accessoryType = Response.value;
            this.getBy === 'accessoryType' ? (this.type = this.accessoryType) : '';
            // console.log(this.getBy);

            this.router.routeReuseStrategy.shouldReuseRoute = function() {
                return false;
            };
        });
    }

    ngOnInit() {
        // reset
        this.minValue = 0;
        this.maxValue = 2000;
        this.sortDatePrice = 'new';
        this.getBrandsList();
        this.getAccessoryType();
        this.getAccessoryList();

        this.bannerService.getBanner('adsLeft').subscribe((res: Banner) => {
            this.banners = res;
        });
    }

    getAccessoryType() {
        this.AccessaryService.getType().subscribe((res: Category) => {
            this.cat = res;
        });
    }

    onFilter() {
        this.getAccessoryList();
    }

    getAccessoryList() {
        // $('html, body').animate({ scrollTop: 0 }, 'slow');
        let offset = (this.page - 1) * 28;

        this.AccessaryService.getDeviceList(
            offset,
            this.accessoryType,
            this.brandName,
            this.minValue,
            this.maxValue,
            this.sortDatePrice
        ).subscribe(res => {
            let data = (res as any).data;
            this.metadata = (res as any).metadata;
            this.accessories = data;
        });
    }

    getBrandsList() {
        this.AccessaryService.getBrand().subscribe((res: Brand) => {
            this.brands = res;
            // console.log(res);
        });
    }
}
